// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"239c888b","945":"c665e6a0"}[chunkId] + ".chunk.js";
};